import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { Button, Table } from "antd";
import { useModel } from "../../../models";
import { goPage } from "../../layout/pageDefinition";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

const columns = [
    {
        title: '序号',
        width: 50,
        render: (_, __, index) => <span>{index + 1}</span>,
    },

    {
        title: '商品编号',
        width: 120,
        dataIndex: 'materialCode',
    },
    {
        title: '商品名称',
        width: 200,
        dataIndex: 'materialName',
        align: 'left',
    },
    {
        title: '图号',
        width: 120,
        dataIndex: 'replaceNum',
    },
    {
        title: '发动机型号',
        width: 120,
        dataIndex: 'engineTypeName',
    },
    {
        title: '库存',
        width: 120,
        dataIndex: 'inventoryNum',
    },

    {
        title: '进货价',
        width: 100,
        dataIndex: 'purchasePrice',
    },
    {
        title: '采购频次',
        width: 120,
        dataIndex: 'purchaseFrequency',
    },
    {
        title: '采购数量',
        width: 80,
        dataIndex: 'purchaseNum',
    },
    {
        title: '采退频次',
        width: 80,
        dataIndex: 'preturnFrequency',
    },
    {
        title: '采退数量',
        width: 80,
        dataIndex: 'preturnNum',
    },
    {
        title: '周销售频次',
        width: 100,
        dataIndex: 'weekSaleFrequency',
    },
    {
        title: '周销售数量',
        width: 100,
        dataIndex: 'weekSaleNum',
    },
    {
        title: '周销退频次',
        width: 100,
        dataIndex: 'weekSreturnFrequency',
    },
    {
        title: '周销退数量',
        width: 100,
        dataIndex: 'weekSreturnNum',
    },
    {
        title: '月销售频次',
        width: 100,
        dataIndex: 'monthSaleFrequency',
    },
    {
        title: '月销售数量',
        width: 100,
        dataIndex: 'monthSaleNum',
    },
    {
        title: '月销退频次',
        width: 100,
        dataIndex: 'monthSreturnFrequency',
    },
    {
        title: '月销退数量',
        width: 100,
        dataIndex: 'monthSreturnNum',
    },
    {
        title: '2月销售频次',
        width: 120,
        dataIndex: 'twoMonthSaleFrequency',
    },
    {
        title: '2月销售数量',
        width: 150,
        dataIndex: 'twoMonthSaleNum',
    },
    {
        title: '2月销退频次',
        width: 150,
        dataIndex: 'twoMonthSreturnFrequency',
    },
    {
        title: '2月销退数量',
        width: 150,
        dataIndex: 'twoMonthSreturnNum',
    },
    {
        title: '自定义销售频次',
        width: 120,
        dataIndex: 'customSaleFrequency',
    },
    {
        title: '自定义销售数量',
        width: 120,
        dataIndex: 'customSaleNum',
    },
    {
        title: '自定义销退频次',
        width: 120,
        dataIndex: 'customSreturnFrequency',
    },
    {
        title: '自定义销退数量',
        width: 120,
        dataIndex: 'customSreturnNum',
    },
];


export default function () {
    const [
        { searchParam, partDealList, partDealListSelectedRowKeys, searcnPage },
        { loadListDetail, setPartDealListSelectedRowKeys, exportPartDealList }
    ] = useModel("partDealModel");

    // useEffect(() => {
    //     const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
    //     const { pageSize, pageNum } = searcnPage
    //     const { materialCode, customerName, category } = searchParam;
    //     let data = {
    //         startTime,
    //         endTime,
    //         pageSize,
    //         pageNum,
    //         materialCode, // "商品编号"
    //         customerName, //  "客户名称"
    //         category, // "商品类型 "
    //     }
    //     loadListDetail({ showMsg: true, data })
    // }, []);

    const history = useHistory();

    const onExport = () => {
        const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
        const { materialCode, customerName, category } = searchParam;
        let data = {
            startTime,
            endTime,
            materialCode, // "商品编号"
            customerName, //  "客户名称"
            category, // "商品类型 "
        }
        exportPartDealList({ showMsg: true, data });
    }

    const TableHeader = () => {
        return (
            <div style={{ margin: "0 0 8px", display: "flex" }}>
                <div style={{ width: "460px", paddingTop: "6px" }}>
                    <YhAuth resCode={ResourceAuthEnum.STTICS_TRADE_EX}>
                        <Button className="margin-left-8" onClick={onExport}>导出</Button>
                    </YhAuth>
                </div>
                <div className="detail-list-statistic" style={{ textAlign: "right" }}>

                </div>
            </div>
        )
    }
    return (
        <>
            <TableHeader />
            <Table
                columns={columns}
                dataSource={partDealList}
                bordered
                pagination={{
                    hideOnSinglePage: false,
                    showSizeChanger: true,
                    pageSizeOptions: [15, 50, 100, 200, 500],
                    defaultCurrent: 1,
                    defaultPageSize: 15,
                    onChange: (pageNum, pageSize) => {
                        // console.log(pageNum, pageSize)
                        /*const params = {...searchParam};
                        params.pageNum = pageNum;
                        params.pageSize = pageSize;*/
                        const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
                        const { materialCode, customerName, category, materialName } = searchParam;
                        const data = {
                            materialCode, customerName, category, materialName,
                            startTime, endTime, pageNum, pageSize
                        }
                        loadListDetail({ showMsg: false, data });
                    },
                    total: searcnPage.total,
                    current: searcnPage.pageNum,
                }}
                // onRow={record => {
                //     return {
                //         onClick: event => {
                //             if (partDealListSelectedRowKeys
                //                 && partDealListSelectedRowKeys[0]
                //                 && partDealListSelectedRowKeys[0] === record.ey) {
                //                 setPartDealListSelectedRowKeys([]);
                //             } else {
                //                 setPartDealListSelectedRowKeys([record.key]);
                //             }
                //         },
                //     };
                // }}
                // rowSelection={{
                //     type: "radio",
                //     onChange: (selectedRowKeys) => {
                //         setPartDealListSelectedRowKeys(selectedRowKeys)
                //     },
                //     selectedRowKeys: partDealListSelectedRowKeys
                // }}
                scroll={{ x: 'max-content', y: 2000 }}
            />
        </>
    );
}